import { useToast } from '@chakra-ui/react';
import { useNavigate } from 'react-router';

import { AuthLayout } from '../components/AuthLayout';
import { LoginForm } from '../components/LoginForm';

export const Login = () => {
  const toast = useToast();
  const navigate = useNavigate();

  return (
    <AuthLayout title="Comercial digital">
      <LoginForm
        onSuccess={() => {
          navigate('/dashboard');
          toast({
            title: 'Login efetuado com sucesso!',
            status: 'success',
            duration: 5000,
            isClosable: true,
          });
        }}
        onError={(message) => {
          if (message === 'User need make first login') {
            navigate('/primeiro-acesso');

            toast({
              title: 'O usuário precisa fazer o primeiro login!',
              status: 'warning',
              duration: 5000,
              isClosable: true,
            });

            return;
          }

          toast({
            title: message,
            status: 'error',
            duration: 5000,
            isClosable: true,
          });
        }}
      />
    </AuthLayout>
  );
};
